export const timeoutErrorMessage =
  'Something went wrong. Please try again later.';
export const exportDelayErrorMessage =
  "Your records are being exported. This may take some time. An email will be sent once it's ready.";

export const ApiErrorMessages = {
  ADDON_SAVED_TRANSLATION_FAILED: {
    message: 'Add-on saved, but translation failed.',
    variant: 'warning',
  },
  ADDON_WITH_NAME_EXISTS: {
    message: 'An add-on with the same name already exists.',
    variant: 'error',
  },
};

export const ApiSuccessMessages = {
  ADDON_SUCCESSFULLY_SAVED: {
    message: 'Add-on successfully saved.',
    variant: 'success',
  },
};
